module.exports = __webpack_public_path__ + "media/dorobek/assets/images/chapter-83cde2b070c8f6a08166c391f5468bbd.svg";